import Error from '../model/Error';
import axios from 'axios';

export default class ClubInvoicePaymentRepository {
    static deleteByClubInvoiceId(clubInvoiceId) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/club/club-invoices/${clubInvoiceId}/invoice-payments`)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static deleteById(paymentId) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/club/club-invoice-payments/${paymentId}`)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static createByClubInvoiceId(clubInvoiceId, data) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/club/club-invoices/${clubInvoiceId}/invoice-payments`, data)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
